module.exports = __webpack_public_path__ + "static/media/july2020.88336472.jpg";